export const images = {
	myPhoto: require("./myPhoto3.jpg"),
	myPhoto1: require("./myPhoto3.jpg"),
};

export const icons = {
	html: require("./icons/html.png"),
	css: require("./icons/css.png"),
	js: require("./icons/js.png"),
	chakra: require("./icons/chakra-ui.webp"),
	material: require("./icons/material-ui.webp"),
	next: require("./icons/next-js_1.webp"),
	react: require("./icons/react.png"),
	redux: require("./icons/redux.png"),
	code: require("./icons/code.png"),
	github: require("./icons/github.png"),
	bootstrap: require("./icons/bootstrap.png"),
	jquery: require("./icons/jquery.gif"),
	tailwindcss: require("./icons/tailwindcss.png"),
};

export const projects = {
	// HTML & CSS
	kasper: require("./projectsPhotos/kasper.png"),
	leon: require("./projectsPhotos/leon.png"),
	information: require("./projectsPhotos/information.png"),
	terms: require("./projectsPhotos/terms.png"),
	slide: require("./projectsPhotos/slide.png"),
	health: require("./projectsPhotos/health.png"),
	cf: require("./projectsPhotos/cf.png"),

	// JavaScript
	travel: require("./projectsPhotos/Travel.png"),
	portfolio: require("./projectsPhotos/portfolio.png"),
	happy: require("./projectsPhotos/happy.png"),
	holux: require("./projectsPhotos/holux.png"),
	avarage: require("./projectsPhotos/avarage.png"),
	app: require("./projectsPhotos/app.png"),

	// React.js
	covied: require("./projectsPhotos/covied.png"),
	risk: require("./projectsPhotos/risk.png"),
	tracker: require("./projectsPhotos/tracker.png"),
	krypt: require("./projectsPhotos/krypt.png"),
	crypto: require("./projectsPhotos/crypto.png"),
	house: require("./projectsPhotos/house.png"),
	// Next.js

	// Mern Stack
};

export const skills = {
	html: require("./skills/html.png"),
	css: require("./skills/css.png"),
	mu5: require("./skills/mu5.png"),
	chakra: require("./skills/chakra-ui.webp"),
	tailwindcss: require("./skills/tailwindcss.png"),
	bootstrap: require("./skills/bootstrap.png"),
	sass: require("./skills/sass.png"),
	javascript: require("./skills/javascript.png"),
	react: require("./skills/react.png"),
	redux: require("./skills/redux.png"),
	api: require("./skills/api.png"),
	typescript: require("./skills/typescript.png"),
	git: require("./skills/git.png"),
	code: require("./skills/code.png"),
};
